import React from 'react'
import { useNavigate } from 'react-router-dom'

import FaberOrOrbit from '../../../common/FaberOrOrbit'

const pageHeader = 'Manage Vouchers'

export default function FaberOrOrbitVouchers() {
  const navigate = useNavigate()

  function orbitBtnOnClick() {
    // Do nothing for now until Orbit page is made
    // navigate('manage-vouchers-orbit')
  }

  function faberBtnOnClick() {
    navigate('manage-vouchers-faber')
  }

  return (
    <FaberOrOrbit
      pageHeader={pageHeader}
      orbitBtnOnClick={orbitBtnOnClick}
      faberBtnOnClick={faberBtnOnClick}
    />
  )
}
